import React from 'react';
var InjectHTML = function InjectHTML(_ref) {
  var htmlString = _ref.htmlString;
  return /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: htmlString
    }
  });
};
export default InjectHTML;